// extracted by mini-css-extract-plugin
module.exports = {"courses":"electric_courses__2iPl6","img1":"electric_img1__22G-c","img2":"electric_img2__3oIOV","img3":"electric_img3__3h4Te"};